export function entitiesListSelector(state, entitiesName) {
  const entities = state.entities[entitiesName];
  return entities.allIds.map(entityId => {
    return entities.byId[entityId];
  });
}



// WEBPACK FOOTER //
// ./src/selectors/entitiesListSelector.js